// 📂 src/hooks/useTasa.ts
import { tasaDoc } from '@/backend/firebase/services'; // Tu referencia al doc
import type { Tasa } from '@/shared/schema';
import { useQuery } from '@tanstack/react-query';
import { getDoc } from 'firebase/firestore';

export const useTasa = () => {
  return useQuery({
    queryKey: ['tasa'],
    queryFn: async () => {
      try {
        const snapshot = await getDoc(tasaDoc());
        const data = snapshot.data();

        if (!data) throw new Error('No hay datos de tasa disponibles');

        // Calculamos la tasa derivada EUR -> BS para ahorrar cálculos en el front
        const eurToBs = data.currentTasa * data.eurToUsd;

        return {
          ...data,
          eurToBs: Number(eurToBs.toFixed(2)),
          euro: Number(eurToBs.toFixed(2)), // 👈 Añadido para el layout
          currentTasa: Number(data.currentTasa.toFixed(2)),
          copTasa: Number((data as any).copTasa?.toFixed(2) || 4000),
          // Label para mostrar en la UI de los salones
          legalLabel: `Tasa BCV: ${data.currentTasa.toFixed(2)} Bs.`,
        } as Tasa;
      } catch (e) {
        console.error('⚠️ [Tasa] Usando tasa de respaldo (Offline/Fallback):', e);
        // Fallback para evitar bloqueo total de la UI en demos o nuevos proyectos
        const fallbackTasa = 36.50;
        return {
          currentTasa: fallbackTasa,
          eurToUsd: 1.08,
          eurToBs: fallbackTasa * 1.08,
          euro: fallbackTasa * 1.08,
          copTasa: 4000,
          legalLabel: `Tasa BCV (Resp): ${fallbackTasa.toFixed(2)} Bs.`,
          updatedAt: new Date()
        } as Tasa;
      }
    },
    staleTime: 1000 * 60 * 15, // 15 minutos es suficiente para BCV
  });
};
